import { Outlet } from 'react-router-dom'
import { Navbar } from './components'
import './App.module.css'

function App() {
  return (
    <>
    <Navbar />
    <Outlet />
    </>
  );
}

export default App;
